import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';

// --- Styled Components ---

const SectionWrapper = styled.section`
  background-color: #0b0f19;
  color: #ffffff;
  padding: 80px 0;
  text-align: center;
`;

const HeaderDescription = styled.p`
  color: #a0aec0;
  font-size: 1rem;
  max-width: 500px;
  margin: 15px auto 40px auto;
  line-height: 1.6;
`;

// This component just holds all the rows
const LogoRowContainer = styled.div`
  display: flex;
  flex-direction: column; // Stack the rows vertically
  align-items: center;
`;

// This is the new component for an individual row
const LogoRow = styled.div`
  display: flex;
  flex-wrap: wrap; // Allows logos to wrap on small screens
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px; // Space between rows

  // On larger screens, we prevent wrapping to force the 4-3 pattern
  @media (min-width: 992px) {
    flex-wrap: nowrap;
  }
`;

const LogoPill = styled.div`
  background-color: #1a202c;
  border: 1px solid #2d3748;
  border-radius: 50px;
  padding: 12px 24px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: translateY(-3px);
    background-color: #2d3748;
    border-color: #4a5568;
  }
`;

const LogoImage = styled.img`
  max-height: 28px;
  width: auto;
  max-width: 130px;
  object-fit: contain;
`;

// --- Logo Data ---
const customers = [
  { name: 'Databricks', domain: 'databricks.com' },
  { name: 'ServiceTitan', domain: 'servicetitan.com' },
  { name: 'Culture Amp', domain: 'cultureamp.com' },
  { name: 'Grammarly', domain: 'grammarly.com' },
  { name: 'Webflow', domain: 'webflow.com' },
  { name: 'Chainalysis', domain: 'chainalysis.com' },
  { name: 'Gong', domain: 'gong.io' },
  { name: 'Razorpay', domain: 'razorpay.com' },
  { name: 'Checkout.com', domain: 'checkout.com' },
  { name: 'MessageBird', domain: 'messagebird.com' },
  { name: 'Yardi', domain: 'yardi.com' },
  { name: 'Loom', domain: 'loom.com' },
  { name: 'Attentive', domain: 'attentivemobile.com' },
  { name: 'Kong', domain: 'konghq.com' },
  { name: 'Hopin', domain: 'hopin.com' },
  { name: 'Airwallex', domain: 'airwallex.com' },
  { name: 'Slack', domain: 'slack.com' },
  { name: 'Amplitude', domain: 'amplitude.com' },
];

// --- Helper Function ---
/**
 * Splits an array into chunks based on a repeating pattern.
 * e.g., chunkArrayByPattern(array, [4, 3])
 * will return [[...4 items], [...3 items], [...4 items], ...]
 */
function chunkArrayByPattern(arr, pattern) {
  const result = [];
  let currentIndex = 0;
  let patternIndex = 0;

  while (currentIndex < arr.length) {
    const chunkSize = pattern[patternIndex % pattern.length];
    const chunk = arr.slice(currentIndex, currentIndex + chunkSize);
    result.push(chunk);
    currentIndex += chunkSize;
    patternIndex++;
  }

  return result;
}

// --- The Main Component ---

const CustomerLogos = () => {
  // Define the layout pattern: 4 logos, then 3, repeating
  const layoutPattern = [4, 3];
  const logoRows = chunkArrayByPattern(customers, layoutPattern);

  return (
    <SectionWrapper>
      <Container>
        <h2>Notable Satisfied Customers</h2>
        <HeaderDescription>
          Notable satisfied customers can be an excellent source of marketing for
          any business. These customers can serve as brand ambassadors.
        </HeaderDescription>

        <LogoRowContainer>
          {logoRows.map((row, rowIndex) => (
            <LogoRow key={rowIndex}>
              {row.map((customer) => (
                <LogoPill key={customer.name}>
                  <LogoImage
                    src={`https://logo.clearbit.com/airwallex.com`}
                    alt={`${customer.name} logo`}
                  />
                </LogoPill>
              ))}
            </LogoRow>
          ))}
        </LogoRowContainer>
      </Container>
    </SectionWrapper>
  );
};

export default CustomerLogos;